module.exports = __webpack_public_path__ + "static/media/emissor-b-3.78b174bc.png";